import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { useTranslation } from 'react-i18next';

import { Text, Icon, Button } from '../Elements';

import classes from './FilterButton.module.scss';

const FilterButton = ({ active = false, onClick, disabled = false }) => {
  const { t } = useTranslation(['activity']);

  return (
    <Button
      className={cn(
        classes.button,
        active ? classes.active : '',
        disabled ? classes.disabled : ''
      )}
      onClick={disabled ? undefined : onClick}
      disabled={disabled}
    >
      <Icon size="16px" icon="filterBig" className={classes.button_icon} />
      <Text className={classes.button_text} weight="m">
        {t('activity:buttons.FILTER')}
      </Text>
    </Button>
  );
};

FilterButton.propTypes = {
  active: PropTypes.bool,
  onClick: PropTypes.func,
  disabled: PropTypes.bool
};

export default FilterButton;
